import React from 'react';

import { Loading } from 'components/shared/Loading';

import { EmptyState } from 'components/EmptyState';
import { TablePagination } from 'components/TablePagination';

import { Actions } from 'pages/InboxPage/components/Actions';
import { SurveyItem } from 'pages/InboxPage/components/SurveyItem';

import styles from './Surveys.module.scss';

const Surveys = ({
  locale,
  loading,
  surveys,
  currentPage,
  totalPages,
  perPage,
  sortParams,
  onPerPageChange,
  onPrevPageClick,
  onNextPageClick,
  onSortChange,
}: {
  locale: any;
  loading: any;
  surveys: any;
  currentPage: any;
  totalPages: any;
  perPage: any;
  sortParams: any;
  onPerPageChange: any;
  onPrevPageClick: any;
  onNextPageClick: any;
  onSortChange: any;
}) => (
  <>
    {loading ? (
      <Loading />
    ) : surveys.length > 0 ? (
      <>
        <Actions onSortChange={onSortChange} sortParams={sortParams} />
        {surveys.map((survey: any) => (
          <div className={styles.item} key={survey.id}>
            <SurveyItem survey={survey} locale={locale} />
          </div>
        ))}
        <TablePagination
          currentPage={currentPage}
          perPage={perPage}
          totalPages={totalPages}
          onPerPageChange={onPerPageChange}
          onNextPageClick={onNextPageClick}
          onPrevPageClick={onPrevPageClick}
        />
      </>
    ) : (
      <EmptyState
        className={styles.emptyState}
        icon="mail"
        title="There aren’t surveys yet."
        text=""
      />
    )}
  </>
);
export default React.memo(Surveys) as any;
